import {
    AdvancedFilterFieldTypesEnum,
    IConditionAdvancedFilter,
    IMetadataAdvancedFilters
} from "../../shared/advanced-filters/components/advance-filter";
import {IMetadataItemDto} from "../settings/documentfields/metadata-item.dto";


export enum ContractControlGeneralDataTypeEnum{
    start_date='start_date',
    end_date='end_date',
    ongoing='ongoing',
    monthly_cost='monthly_cost',
    annual_cost='annual_cost',
    total_cost='total_cost',
    monthly_revenue='monthly_revenue',
    annual_revenue='annual_revenue',
    total_revenue='total_revenue',
    auto_renewal_date='auto_renewal_date'
}

export interface ICCGeneralDataAdvancedFilter {
    field_type: AdvancedFilterFieldTypesEnum.general_field,
    general_data_type:  ContractControlGeneralDataTypeEnum
    value:string;
    operator:string
}

export type ContractControlAdvanceFilterParamType = IMetadataItemDto | IMetadataAdvancedFilters | IConditionAdvancedFilter | ICCGeneralDataAdvancedFilter;
